"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6514],{

/***/ 6055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ SHIPPED_TAB_VALUE; },
/* harmony export */   "B$": function() { return /* binding */ FULLORDER_TAB_VALUE; },
/* harmony export */   "Fx": function() { return /* binding */ ODP_ANALYTICS_ORDER_SUPPORT; },
/* harmony export */   "HP": function() { return /* binding */ SHIPPED_TAB_ANALYTICS; },
/* harmony export */   "Hl": function() { return /* binding */ ORDER_TYPE_SERVICE; },
/* harmony export */   "K6": function() { return /* binding */ CANCELLED_TAB_ANALYTICS; },
/* harmony export */   "L": function() { return /* binding */ SERVICES_SHIPPING_TYPE; },
/* harmony export */   "Pl": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REJECTED; },
/* harmony export */   "RS": function() { return /* binding */ ODP_ORDER_SUPPORT_EVENT; },
/* harmony export */   "UC": function() { return /* binding */ RETURNED_TAB_ANALYTICS; },
/* harmony export */   "Ur": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_CANCELLED; },
/* harmony export */   "V0": function() { return /* binding */ TAB_ANALYTICS_EVENT; },
/* harmony export */   "Vz": function() { return /* binding */ FULLORDER_TAB_ANALYTICS; },
/* harmony export */   "X6": function() { return /* binding */ CANCELLED_TAB_VALUE; },
/* harmony export */   "YW": function() { return /* binding */ LINE_ITEM_STATUS_SHIPPED; },
/* harmony export */   "aK": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME; },
/* harmony export */   "am": function() { return /* binding */ NON_SHIPPED_TABS; },
/* harmony export */   "b8": function() { return /* binding */ ORDER_TYPES_SORT_SEQUENCE; },
/* harmony export */   "cK": function() { return /* binding */ ODP_ANALYTICS_PAGE; },
/* harmony export */   "dm": function() { return /* binding */ LINE_ITEM_STATUS_CANCELLED; },
/* harmony export */   "dt": function() { return /* binding */ ODP_ANALYTICS_NAVIGATION; },
/* harmony export */   "f9": function() { return /* binding */ TABS_TO_SORT; },
/* harmony export */   "hW": function() { return /* binding */ ODP_ANALYTICS_ACCOUNT; },
/* harmony export */   "ik": function() { return /* binding */ INPROGRESS_TAB_ANALYTICS; },
/* harmony export */   "l4": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_ACCEPTED; },
/* harmony export */   "mI": function() { return /* binding */ RETURN_STATUS_SORT_ORDER; },
/* harmony export */   "mJ": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME; },
/* harmony export */   "mu": function() { return /* binding */ ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION; },
/* harmony export */   "rb": function() { return /* binding */ INPROGRESS_TAB_VALUE; },
/* harmony export */   "sN": function() { return /* binding */ LINE_ITEM_STATUS_INPROGRESS; },
/* harmony export */   "uN": function() { return /* binding */ LINE_ITEM_STATUS_RETURN_REQUESTED; },
/* harmony export */   "vy": function() { return /* binding */ RETURNED_TAB_VALUE; }
/* harmony export */ });
/* unused harmony exports ODP_CUSTOMER_SUPPORT_LINK_TYPE, LINE_ITEM_STATUS_RETURN_CREATED, ORDER_TYPE_PARCEL, ORDER_TYPE_FREIGHT */
const INPROGRESS_TAB_VALUE = "inprogress";
const FULLORDER_TAB_VALUE = "fullorder";
const SHIPPED_TAB_VALUE = "shipped";
const RETURNED_TAB_VALUE = "returned";
const CANCELLED_TAB_VALUE = "cancelled";
const FULLORDER_TAB_ANALYTICS = "Full Order";
const SHIPPED_TAB_ANALYTICS = "Shipped";
const INPROGRESS_TAB_ANALYTICS = "In Progress";
const RETURNED_TAB_ANALYTICS = "Returned";
const CANCELLED_TAB_ANALYTICS = "Cancelled";
const TAB_ANALYTICS_EVENT = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME = "my account:orders:order details";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME = "track package";
const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION = "my account";
const ODP_ORDER_SUPPORT_EVENT = "my account:orders:order summary";
const ODP_ANALYTICS_PAGE = "orders";
const ODP_ANALYTICS_ACCOUNT = "my account";
const ODP_ANALYTICS_ORDER_SUPPORT = "order details:order support";
const ODP_ANALYTICS_NAVIGATION = "navigation";
const ODP_CUSTOMER_SUPPORT_LINK_TYPE = "order details:customer support";
const LINE_ITEM_STATUS_CANCELLED = "Cancelled";
const LINE_ITEM_STATUS_INPROGRESS = "In Progress";
const LINE_ITEM_STATUS_RETURN_CREATED = "Return Created";
const LINE_ITEM_STATUS_SHIPPED = "Shipped";
const LINE_ITEM_STATUS_RETURN_REQUESTED = "Return Requested";
const LINE_ITEM_STATUS_RETURN_ACCEPTED = "Return Accepted";
const LINE_ITEM_STATUS_RETURN_REJECTED = "Return Rejected";
const LINE_ITEM_STATUS_RETURN_CANCELLED = "Return Cancelled";
const ORDER_TYPE_PARCEL = "Parcel";
const ORDER_TYPE_FREIGHT = "Freight";
const ORDER_TYPE_SERVICE = "Service";
const TABS_TO_SORT = [
    SHIPPED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const NON_SHIPPED_TABS = [
    RETURNED_TAB_VALUE,
    INPROGRESS_TAB_VALUE,
    CANCELLED_TAB_VALUE
];
const RETURN_STATUS_SORT_ORDER = [
    LINE_ITEM_STATUS_RETURN_REQUESTED,
    LINE_ITEM_STATUS_RETURN_ACCEPTED,
    LINE_ITEM_STATUS_RETURN_REJECTED,
    LINE_ITEM_STATUS_RETURN_CANCELLED
];
const ORDER_TYPES_SORT_SEQUENCE = [
    ORDER_TYPE_PARCEL,
    ORDER_TYPE_FREIGHT,
    ORDER_TYPE_SERVICE
];
const SERVICES_SHIPPING_TYPE = [
    "INSTALL SERVICES",
    "DESIGN SERVICES"
];


/***/ }),

/***/ 54114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getProductImageAlt; },
/* harmony export */   "Hr": function() { return /* binding */ getAllAdditinalInfo; },
/* harmony export */   "PZ": function() { return /* binding */ checkReturnStatus; },
/* harmony export */   "S": function() { return /* binding */ getTmpType; },
/* harmony export */   "WS": function() { return /* binding */ getReturnStatusDescription; },
/* harmony export */   "bO": function() { return /* binding */ servicesItem; },
/* harmony export */   "lk": function() { return /* binding */ getDiscountPrice; },
/* harmony export */   "oH": function() { return /* binding */ getFormattedTabNameForAnalytics; }
/* harmony export */ });
/* harmony import */ var _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6055);

const getTmpType = (param)=>{
    let { category , i18n  } = param;
    var ref;
    const categoryType = (ref = category === null || category === void 0 ? void 0 : category.toLowerCase()) !== null && ref !== void 0 ? ref : "";
    const { perBox ="" , bucket ="" , perEach =""  } = i18n !== null && i18n !== void 0 ? i18n : {};
    if ((categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("tile")) || (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("mosaics"))) {
        return perBox === null || perBox === void 0 ? void 0 : perBox.toLowerCase();
    } else if (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("grout")) {
        return "/".concat(bucket === null || bucket === void 0 ? void 0 : bucket.toLowerCase());
    } else if (categoryType === null || categoryType === void 0 ? void 0 : categoryType.includes("trim")) {
        return "".concat(perEach === null || perEach === void 0 ? void 0 : perEach.toLowerCase());
    } else {
        return "";
    }
};
const getAllAdditinalInfo = (e)=>{
    var ref;
    var ref1;
    const { totalarea: totalArea = "" , totaloverageval: overage = "" , soldbyuom: soldByUom = "" , soldbybox: soldByBox = "" , templatetype: templateType = "" , price ="" , name ="" , desc ="" , image ="" , currencysign: currencySign = "" , totalneeded: totalNeeded = "" , discountprice: discountPrice = "" , totalprice: totalPrice = "" , totalSFNeeded ="" , totalUserNeeded ="" , totalSFUserNeeded ="" , totalboxes: totalBoxes = ""  } = (ref1 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.dataset) !== null && ref1 !== void 0 ? ref1 : {};
    return {
        totalArea,
        overage,
        soldByUom,
        soldByBox,
        templateType,
        price,
        name,
        desc,
        image,
        currencySign,
        totalNeeded,
        discountPrice,
        totalPrice,
        totalSFNeeded,
        totalUserNeeded,
        totalSFUserNeeded,
        totalBoxes
    };
};
const getDiscountPrice = (discountPrice, discountUnitPrice, unitPrice)=>{
    if (discountPrice > 0) {
        return discountPrice;
    } else if (discountUnitPrice > 0) {
        return discountUnitPrice;
    } else {
        return unitPrice;
    }
};
const getReturnStatusDescription = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", staticText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, returnCancelledMessage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", returnRejectedMessage = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const { returnRequestedDescription ="" , returnAcceptedDescription =""  } = staticText;
    switch(status){
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REQUESTED */ .uN:
            return returnRequestedDescription;
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_ACCEPTED */ .l4:
            return returnAcceptedDescription;
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REJECTED */ .Pl:
            return returnRejectedMessage.replace(/<\/?p>/g, "");
        case _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_CANCELLED */ .Ur:
            return returnCancelledMessage.replace(/<\/?p>/g, "");
        default:
            return "";
    }
};
const checkReturnStatus = function() {
    let status = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const returnStatuses = [
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REQUESTED */ .uN,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_ACCEPTED */ .l4,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_REJECTED */ .Pl,
        _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .LINE_ITEM_STATUS_RETURN_CANCELLED */ .Ur
    ];
    return returnStatuses.includes(status);
};
const getFormattedTabNameForAnalytics = function() {
    let tabName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const formattedTabNames = {
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .FULLORDER_TAB_VALUE */ .B$]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .FULLORDER_TAB_ANALYTICS */ .Vz,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_VALUE */ .$Q]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SHIPPED_TAB_ANALYTICS */ .HP,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_VALUE */ .rb]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .INPROGRESS_TAB_ANALYTICS */ .ik,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_VALUE */ .vy]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .RETURNED_TAB_ANALYTICS */ .UC,
        [_components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_VALUE */ .X6]: _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .CANCELLED_TAB_ANALYTICS */ .K6
    };
    return ((ref = formattedTabNames[tabName]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
};
const servicesItem = (category)=>{
    if (!category) return false;
    var ref;
    const categoryType = (ref = category === null || category === void 0 ? void 0 : category.toUpperCase()) !== null && ref !== void 0 ? ref : "";
    return _components_OrderConfirmation_OrderDetailsTabs_constant__WEBPACK_IMPORTED_MODULE_0__/* .SERVICES_SHIPPING_TYPE.includes */ .L.includes(categoryType);
};
const getProductImageAlt = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { name ="" , desc ="" , color =""  } = data;
    let altText = name || "";
    if (desc && name !== desc) {
        altText += ", ".concat(desc);
    }
    if (color && color !== "Not Applicable") {
        altText += ", ".concat(color);
    }
    return altText;
};


/***/ }),

/***/ 96514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ addSharedCartItemSummaryAnalytics; },
/* harmony export */   "Jk": function() { return /* binding */ addCartItemSummaryAnalytics; },
/* harmony export */   "UN": function() { return /* binding */ addRemoveProductFromCartAnalytics; },
/* harmony export */   "au": function() { return /* binding */ addDatalayer; },
/* harmony export */   "u$": function() { return /* binding */ analyticsCB; }
/* harmony export */ });
/* unused harmony export calculateCartAnalytics */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20558);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96301);
/* harmony import */ var _components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54114);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88032);





const analyticsCB = function(status) {
    let cartObjData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    const { itemSkus =[] , ...cartObj } = cartObjData;
    const page = window.pageObj || {};
    if (status !== "success" && page.eventInfo) {
        page.eventInfo.eventStatus = "failure";
        page.eventInfo.eventMsg = status || "failed to update item(s) in cart.";
        const otherItems = {};
        if (page.updatedSku) {
            var ref1, ref2;
            // get productInfo and add to event page objet.
            const matchingSku = (ref1 = page.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.find((prod)=>{
                var ref, ref1;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === page.updatedSku.toLowerCase();
            });
            if (matchingSku) {
                otherItems.productInfo = matchingSku.productInfo;
            }
        }
        otherItems.eventInfo = page.eventInfo;
        delete page.eventInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            ...otherItems
        });
    } else if (page.eventInfo && cartObj) {
        calculateCartAnalytics({
            itemSkus,
            cart: cartObj,
            eventName: "cmp:click"
        });
    }
    if (window === null || window === void 0 ? void 0 : (ref = window.pageObj) === null || ref === void 0 ? void 0 : ref.updatedSku) {
        delete window.pageObj.updatedSku;
    }
    if (window.pageObj) {
        window.pageObj.cart = cartObj;
    }
    let windowDataLayer = window.adobeDataLayer;
    if (windowDataLayer && windowDataLayer.length > 0 && windowDataLayer[0].page) {
        calculateCartAnalytics({
            itemSkus,
            cart: cartObj
        });
        windowDataLayer = window.adobeDataLayer;
        const winDataLayer = windowDataLayer[windowDataLayer.length];
        if (windowDataLayer.length > 1 && winDataLayer && winDataLayer.event && (winDataLayer.event === "cmp:show" || winDataLayer.event === "cmp:click") && winDataLayer.page && !winDataLayer.page.cart) {
            winDataLayer.page.cart = cartObj;
        }
    }
};
const calculateCartAnalytics = async (data)=>{
    const { itemSkus , cart: cartData , eventName ="cmp:show"  } = data;
    const cart = await (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .mapCollapsedSku */ .eo)({
        itemSkus,
        cart: cartData
    });
    const page = window.pageObj || {};
    page.cartInfo = page.cartInfo || {};
    const finalSkus = itemSkus && itemSkus.length > 0 ? itemSkus.join(",") : (cartData.item || []).map((item)=>{
        var ref;
        return (ref = item.productInfo) === null || ref === void 0 ? void 0 : ref.productID;
    }).filter(Boolean).join(",");
    page.cartInfo.cartItems = finalSkus;
    page.cart = cart;
    page.user = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .getUserAnalyticsObject */ .L7i)();
    if (eventName === "cmp:show" && page.user && (!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else if (eventName === "cmp:show" && !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .isShowAnalyticsEventLoaded */ .xJ2)() || eventName !== "cmp:show") {
        let otherItems = {};
        if (eventName !== "cmp:show") {
            var ref;
            if (page.eventInfo) {
                otherItems = {
                    eventInfo: page.eventInfo
                };
                delete page.eventInfo;
            }
            const matchedItem = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.find((prod)=>{
                var ref;
                return ((ref = prod.productInfo) === null || ref === void 0 ? void 0 : ref.productUpdated) === true;
            });
            if (matchedItem) {
                // here check initialQuantity from oldCart object.
                if (window.oldValue) {
                    matchedItem.productInfo.initialQuantity = window.oldValue;
                    delete window.oldValue;
                }
                otherItems.productInfo = matchedItem.productInfo;
            }
        }
        window.adobeDataLayer.push({
            event: eventName,
            page,
            ...otherItems
        });
    }
};
const addCartItemSummaryAnalytics = function(page, prodDesc, prodName, pdpNavigationURL) {
    let isBundleParent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isTabsEnabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, activeTab = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "";
    const selectedTab = (0,_components_cart_CartItemTile_utils__WEBPACK_IMPORTED_MODULE_3__/* .getFormattedTabNameForAnalytics */ .oH)(activeTab);
    const isBundleProduct = isBundleParent && page === "cart" || isBundleParent && page === "checkout" || isBundleParent && page === "pdp" ? ":bundle" : "";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account:orders:".concat(isTabsEnabled ? "order details" : "order summary") : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventMsg: "n/a",
        eventName: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account:orders:".concat(isTabsEnabled ? "order details" : "order summary") : page === "cart" ? "cart preview" : page, ":product navigation"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(prodName || prodDesc),
        internalLinkPosition: page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account" : page + isBundleProduct,
        internalLinkType: "".concat(page !== "cart" && page !== "checkout" && page !== "pdp" ? "my account" : page, ":navigation").concat(page !== "cart" && page !== "checkout" && page !== "pdp" && isTabsEnabled ? ":".concat(selectedTab) : ""),
        internalLinkURL: pdpNavigationURL ? ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL : "n/a",
        internalLinkZoneName: page !== "cart" && page !== "checkout" && page !== "pdp" ? "".concat(isTabsEnabled ? "my account:orders:order details:".concat(selectedTab) : "my account:orders:order summary") : page + ":preview"
    });
};
const addRemoveProductFromCartAnalytics = async function(action) {
    let isBundleParent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", cartItemProductInfo = arguments.length > 2 ? arguments[2] : void 0;
    const eventInfo = {
        eventAction: "cart:landing page:remove",
        eventName: "cart:landing page:remove",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove",
        internalLinkPosition: "cart".concat(isBundleParent ? ":bundle" : ""),
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:cart items",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    sessionStorage.setItem("cartLanding", eventInfo.searchCount);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { cart: { cart: cartObj = {}  } = {}  } = (_store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === null || _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store */ .h === void 0 ? void 0 : _store_index__WEBPACK_IMPORTED_MODULE_4__/* .store.getState */ .h.getState()) || {};
    if (cartObj) {
        const { cart , cartInfo  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .calculateCartData */ .DpP)({
            cart: cartObj
        }, true);
        page.cart = cart;
        page.cartInfo = cartInfo;
    }
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: cartItemProductInfo === null || cartItemProductInfo === void 0 ? void 0 : cartItemProductInfo.productInfo
    });
};
const addDatalayer = (params)=>{
    var ref;
    const { section =null , title =null , productInfo =null , calculatedValues =null , sqaureFeetSelection =null , tooltipVal =null  } = params;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const componentName = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID;
    const productInfoJSON = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.length) > 0 ? {
        productInfo: JSON.parse(productInfo)
    } : null;
    const getcalculatedValues = (calculatedValues === null || calculatedValues === void 0 ? void 0 : calculatedValues.length) > 0 ? JSON.parse(calculatedValues) : null;
    let internalLinkName;
    let internalLinkType;
    if (title === "recalculate footage") {
        internalLinkName = "recalculate";
        internalLinkType = "".concat(componentName, ":navigation");
    } else if (title === "calculate footage") {
        internalLinkName = sqaureFeetSelection ? "square feet changed" : "overage selection";
    } else if (title === "info icon mouseover") {
        internalLinkName = tooltipVal;
        internalLinkType = "".concat(componentName, ":mouseover");
    }
    const eventInfo = {
        eventAction: "".concat(componentName, ":landing page:").concat(section, ":").concat(title),
        eventName: "".concat(componentName, ":landing page:").concat(section, ":").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName || "".concat(title),
        internalLinkPosition: "".concat(componentName),
        internalLinkType: internalLinkType || "".concat(componentName, ":").concat(title),
        internalLinkZoneName: "".concat(componentName, ":landing page:").concat(section),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        ...getcalculatedValues
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        ...productInfoJSON
    });
};
const addSharedCartItemSummaryAnalytics = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", subpage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", prodDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", prodName = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pdpNavigationURL = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", isBundleParent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    const isBundleProduct = isBundleParent ? ":bundle" : "";
    const landingPageInfo = "".concat(page, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES === null || _constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES === void 0 ? void 0 : _constants_index__WEBPACK_IMPORTED_MODULE_2__.PAGE_TYPES.SHARE_CART_LANDING_PAGE);
    const shareCartPage = "".concat(landingPageInfo, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_2__.NAVIGATION_TYPE.PRODUCT);
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: shareCartPage,
        eventMsg: "n/a",
        eventName: shareCartPage,
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(prodName || prodDesc),
        internalLinkPosition: subpage + isBundleProduct,
        internalLinkType: "".concat(subpage, ":navigation"),
        internalLinkURL: pdpNavigationURL ? ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL : "n/a",
        internalLinkZoneName: landingPageInfo
    });
};


/***/ })

}]);